import React, { useMemo, useRef, useState } from 'react'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Button, Input, Select, Table, Modal, message, Checkbox, Tooltip, Tabs, Switch, TimePicker, Divider, Spin, Statistic, Drawer, Popover, InputNumber, Tag, Space } from 'antd';
import { useEffect } from 'react';
import axios from 'axios';
import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';
import moment from 'moment';
import { MdContentCopy, MdPieChartOutlined } from 'react-icons/md';
import { Helmet } from 'react-helmet';
import { ExportToExcelButton, exportToExcel } from '../../Components/ExportToExcel';
import useFilterOptions from '../../Components/useFilterOptions';
import MyConditional from '../../Components/MyConditional';
import SearchComponent from '../../Masters/GeneralComponents/SearchComponent';
import CoptToClipBoardInward from './CopyInwardOutwardDetails';
import { ProductCodeComponent } from '../Components/ProductCodeDetailsModal';
import { copyToClipboard } from '../Components/Functions';
import { useSelector } from 'react-redux';
import { useReactToPrint } from "react-to-print";

const { TabPane } = Tabs;

export default function InwardOutwardReport({
    selectedOrg,
    permissions = {},

    homePath = "/inventory/inward-outward",
}) {
    console.log("InwardOutwardReport");
    let stockTransferId = parseInt(useParams().id);
    console.log(stockTransferId);
    const navigate = useNavigate();

    // For having the active tab in the url (for refreshing)
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'dashboard');
    const changeActiveTab = (key) => {
        setActiveTab(key);
        searchParams.set('tab', key);
        setSearchParams(searchParams, { replace: true });
    }

    const [sessionData, setSessionData] = useState({});
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        setLoading(true);
        await axios.get(`/reports/stock_transfer_info`, {
            params: {
                st_id: stockTransferId,
            }
        })
            .then((res) => {
                const data = res.data.data;
                console.log(data);
                setSessionData(data);
            })
            .catch((err) => {
                console.log(err);
                message.error("Error fetching stock transfer details");
                setSessionData({});
            });
        setLoading(false);
    };

    useEffect(() => {
        getData();
    }, [stockTransferId]);


    return (
        <div className='my-form-outer'>
            <div className='my-form-header'>
                <span className='my-form-title' style={{ textDecoration: 'none', fontSize: '18px', fontWeight: 'unset' }}>
                    Reference Number: <b>{sessionData?.data?.reference_no}</b>
                    &nbsp;&nbsp; | &nbsp;&nbsp;
                    Site :- <u><b>{sessionData?.data?.site}</b></u> &nbsp;&nbsp;&nbsp;&nbsp;Reference Site :-<u><b>{sessionData?.data?.reference_site}</b></u>
                </span>
                <span style={{ textDecoration: 'none', fontSize: '18px', fontWeight: 'unset' }}>
                    <b> {sessionData?.data?.reference_dt}  ({sessionData?.data?.inward_outward})</b>
                </span>
            </div>
            <div>
                <Tabs
                    tabBarExtraContent={
                        <div className='actions-outer-div'>
                            <MyConditional visible={activeTab === 'epc-wise' || activeTab === 'barcode-wise' || activeTab === 'box-wise'}>
                                <ExportRawScannedProductCodes
                                    stockTransferId={stockTransferId}
                                    permissions={permissions}
                                    fileName={`product-codes-${sessionData?.data?.inward_outward}-${sessionData?.data?.reference_no}`}
                                />
                            </MyConditional>
                            <Button type='danger' onClick={() => navigate(homePath + `?report=${sessionData?.data?.inward_outward}`)}>
                                Back
                            </Button>
                        </div>
                    }
                    activeKey={activeTab}
                    onChange={changeActiveTab}
                >
                    <TabPane className="my-form-tabpane-outer" tab="Dashboard" key="dashboard">
                        <div className="my-table-filter-row"  >
                            <div style={{ display: 'inline-flex', flexShrink: 0, gap: '20px' }}>
                                <Statistic loading={loading} title="Valid Count" value={sessionData?.valid_count} />
                                <Statistic loading={loading} title="Expected Count" value={sessionData?.expected_count} />
                                <Statistic
                                    loading={loading}
                                    title="Total Scanned Count"
                                    value={sessionData?.total_count}
                                // style={{marginLeft: '30px'}}
                                />
                                <Statistic loading={loading} title="Extra Count" value={sessionData?.extra_count} />
                                <Statistic style={{ borderBottom: "2px solid red" }} loading={loading} title="Invalid Count" value={sessionData?.invalid_count} />
                                <Statistic loading={loading} title="In-Stock Count" value={sessionData?.in_stock} />
                                <Statistic
                                    loading={loading}
                                    title="Percentage Scanned"
                                    suffix={"%"}
                                    value={(sessionData?.valid_count / sessionData?.expected_count) * 100 || 0}
                                    precision={2}
                                    style={{ marginLeft: '30px' }}
                                />


                            </div>
                        </div>
                    </TabPane>

                    <TabPane tab="Barcode Wise" key="barcode-wise">
                        <BarcodeWiseComparison
                            sessionData={sessionData}
                            stockTransferId={stockTransferId}
                        />
                    </TabPane>
                    <TabPane tab="EPC Comparison" key="epc-wise">
                        <EPCWiseComparison
                            sessionData={sessionData}
                            stockTransferId={stockTransferId}
                        />
                    </TabPane>
                    <TabPane tab="Box Wise" key="box-wise">
                        <BoxWiseComparison
                            sessionData={sessionData}
                            stockTransferId={stockTransferId}
                            ref_site={sessionData?.data?.reference_site}
                        />
                    </TabPane>

                </Tabs>
            </div>
            <Helmet>
                <style>{`
                    .error-row {
                        background-color: var(--errorBgColor);
                    }
                    .success-row {
                        background-color: var(--successBgColor);
                    }
                    .warning-row {
                        background-color: var(--warningBgColor);
                    }
                    .info-row {
                        background-color: var(--infoBgColor);
                    }


                    .ant-table-tbody>tr.ant-table-row:hover>td {
                        background-color: inherit !important;
                        /* border: 1px solid black; */
                        cursor: pointer;
                        {/* font-weight: bold; */}
                    }
                    .ant-table-column-sort{
                        background: none !important;
                    }
                    .ant-table-column-background-none{
                        background: none !important;
                    }
                `}</style>
            </Helmet>
        </div>
    );
}

const ExportRawScannedProductCodes = ({
    stockTransferId,
    permissions = {},
    fileName = `product-codes-${stockTransferId}`,
}) => {
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        await axios.get(`/reports/count_of_product_code`, {
            params: {
                st_id: stockTransferId,
            }
        })
            .then(async (res) => {
                const data = res.data.data;
                const scannedProductCodes = data;

                let productCodeCount = [];
                // we will add the product code the number of times it is scanned
                scannedProductCodes.forEach((item) => {
                    for (let i = 0; i < item.count; i++) {
                        productCodeCount.push({
                            product_code: item.product_code,
                        });
                    }
                });

                exportToExcel({
                    fileName: fileName,
                    sheets: [
                        {
                            sheetName: 'Product Codes and Count',
                            data: scannedProductCodes,
                            columns: [
                                {
                                    title: 'Product Code',
                                    dataIndex: 'product_code',
                                    key: 'product_code',
                                },
                                {
                                    title: 'Count',
                                    dataIndex: 'count',
                                    key: 'count',
                                }
                            ],
                        },
                        {
                            sheetName: 'Product Codes',
                            data: productCodeCount,
                            columns: [
                                {
                                    title: 'Product Code',
                                    dataIndex: 'product_code',
                                    key: 'product_code',
                                }
                            ],
                        }
                    ]
                })

            })
            .catch((err) => {
                console.log(err);
                message.error("Error fetching Data");
            });
        setLoading(false);
    };

    return (
        <Button type='primary' onClick={getData} loading={loading}>
            Export Scanned Product Codes
        </Button>
    );
}

const PDFDocument = ({ data, sessionData }) => {

    const columns = [
        {
            title: 'Sr . No',
            dataIndex: 'index',
            key: 'index',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Product Code',
            dataIndex: 'product_code',
            key: 'product_code',
        },
        {
            title: 'Expected Quantity',
            dataIndex: 'expected_qty',
            key: 'expected_qty',
        },
        {
            title: 'Found Quantity',
            dataIndex: 'found_qty',
            key: 'found_qty',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        }
    ];

    return (
        <div style={{ display: 'flex', width: '100%', flexDirection: 'column', }}>
            <div>
                <h1 style={{ textAlign: 'center' }}>{sessionData?.data?.inward_outward == 'inward' ? 'Inward' : 'Outward'} Report</h1>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <h3>Invoice Number : {sessionData?.data?.reference_no}</h3>
                        <h3>Invoice Date : {sessionData?.data?.reference_dt}</h3>
                        <h3>Scanned Date: {moment(sessionData?.data?.updated_time).format("DD MMM yyyy, hh:mm A")}</h3>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <h3>Stock Transfer ID : {sessionData?.data?.stock_transfer_id}</h3>
                        <h3>Site : {sessionData?.data?.site}</h3>
                    </div>
                </div>
                <Table
                    dataSource={data}
                    columns={columns}
                    pagination={false}
                />
            </div>
        </div>

    )
}

const BarcodeWiseComparison = ({ sessionData, stockTransferId }) => {
    const [masterState, setMasterState] = useState([]);
    const contentRef = useRef(null);

    // The below state is after the search is done
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    // The below var is memoized to avoid re-rendering of the filters when the data is changed, If not, the filters will be calculated again and again infinitely
    const filterableColumns = useMemo(() =>
        ['status', 'product_code']
        , []);
    const [filterOptions, setFilterOptions] = useFilterOptions(masterState, filterableColumns);

    const [categoryColumns, setCategoryColumns] = useState([]);

    const getData = async () => {
        setLoading(true);
        await axios.get(`/report/inward_outward/erpvsrfid`, {
            params: {
                st_id: stockTransferId,
            }
        })
            .then(res => {
                const data = res.data.data;
                const newColumns = res.data.columns;

                setMasterState(data);
                setCategoryColumns(newColumns);
                setData(data);
            })
            .catch(err => {
                console.log(err);
                message.error('Error fetching Barcode_Wise Comparison Data');
            })
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, [stockTransferId]);



    const columns = [
        {
            title: 'Index',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Product Code',
            dataIndex: 'product_code',
            key: 'product_code',
            filters: filterOptions.product_code,
            onFilter: (value, record) => record.product_code == value,
            filterSearch: true,
            render: (text, record) => <ProductCodeComponent productCode={text} />,
        },
        // {
        //     title: 'Reference Number',
        //     dataIndex: 'reference_no',
        //     key: 'reference_no',
        // },
        {
            title: 'Expected Quantity',
            dataIndex: 'expected_qty',
            key: 'expected_qty',
            width: 150,
        },
        {
            title: 'Found Quantity',
            dataIndex: 'found_qty',
            key: 'found_qty',
            width: 150,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filters: filterOptions.status,
            onFilter: (value, record) => record.status == value,
            filterSearch: true,
        }

    ];

    const generatePDF = useReactToPrint({
        content: () => contentRef.current,
        documentTitle: `barcode-wise-${stockTransferId}`,
    });

    return (
        <div className='my-form-outer' style={{ paddingBottom: '20px' }}>
            <div className='my-form-header'>
                <span className="actions-outer-div">
                    <Button onClick={generatePDF}>Export to PDF</Button>
                    <ExportToExcelButton
                        fileName={`barcode-wise-${stockTransferId}`}
                        sheets={[
                            {
                                sheetName: `barcode-wise-${stockTransferId}`,
                                data: data,
                                columns: columns.slice(1, columns.length),
                            },
                        ]}
                        buttonDisabled={loading}
                        buttonLoading={loading}
                    />
                </span>
                <SearchComponent
                    masterState={masterState}
                    state={data}
                    setState={setData}
                    searchOptions={[
                        { keyName: 'product_code', label: 'Product Code' },
                        { keyName: 'status', label: 'Status' },
                    ]}
                />
            </div>

            <div>
                <Table
                    loading={loading}
                    dataSource={data}
                    columns={columns}
                    size='small'
                    bordered
                    pagination={false}
                    rowClassName={(record, index) => {
                        if (record.status === 'LOW') {
                            return 'error-row';
                        }
                        else if (record.status === 'MATCHING') {
                            return 'success-row';
                        }
                        else {
                            return 'warning-row';
                        }
                    }}
                    rowKey={record => record.product_code}
                    expandable={{
                        rowExpandable: record => record?.product_code?.length,
                        expandedRowRender: record => (
                            <ExpandBoxWiseProductCodes
                                stockTransferId={stockTransferId}
                                product_code={record.product_code}
                            />
                        )
                    }}
                />

                <div style={{ display: 'none', justifyContent: 'center', }}>
                    <div style={{ width: "100%", alignItems: 'center', borderStyle: 'groove', padding: "20px", borderWidth: '0.5px' }} ref={contentRef}>
                        <PDFDocument data={data} sessionData={sessionData} />
                    </div>
                </div>
            </div>

        </div>
    );
}

const EPCWiseComparison = ({ sessionData, stockTransferId }) => {
    const [masterState, setMasterState] = useState([]);

    // The below state is after the search is done
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    // The below var is memoized to avoid re-rendering of the filters when the data is changed, If not, the filters will be calculated again and again infinitely
    const filterableColumns = useMemo(() =>
        ['stock_status']
        , []);
    const [filterOptions, setFilterOptions] = useFilterOptions(masterState, filterableColumns);



    const getData = async () => {
        setLoading(true);
        await axios.get(`/report/inward_outward/epc_comparison`, {
            params: {
                st_id: stockTransferId,
            }
        })
            .then(res => {
                const data = res.data.data;
                console.log(data);
                setMasterState(data);
                setData(data);
            })
            .catch(err => {
                console.log(err);
                message.error('Error fetching EPC Comparison Data');
            })
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, [stockTransferId]);

    const columns = [
        {
            title: 'Index',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => index + 1,
        },
        {
            title: 'EPC',
            dataIndex: 'epc',
            key: 'epc',
        },
        {
            title: 'Product Code',
            dataIndex: 'product_code',
            key: 'product_code',
            render: (text, record) => <ProductCodeComponent productCode={text} />,
        },
        {
            title: 'Stock Status',
            dataIndex: 'stock_status',
            key: 'stock_status',
            filters: filterOptions.stock_status,
            onFilter: (value, record) => record.stock_status == value,
            filterSearch: true,
        },
    ];


    return (
        <div className='my-form-outer' style={{ paddingBottom: '20px' }}>
            <div className='my-form-header'>
                <span className="actions-outer-div">
                    <ExportToExcelButton
                        fileName={`EPC-Comparison-${stockTransferId}`}
                        sheets={[
                            {
                                sheetName: `EPC-Comparison-${stockTransferId}`,
                                data: data,
                                columns: columns.slice(1, columns.length),
                            },
                        ]}
                        buttonDisabled={loading}
                        buttonLoading={loading}
                    />
                </span>
                <SearchComponent
                    masterState={masterState}
                    state={data}
                    setState={setData}
                    searchOptions={[
                        { keyName: 'epc', label: 'EPC' },
                        { keyName: 'product_code', label: 'Product Code' },
                        { keyName: 'stock_status', label: 'Stock Status' },
                    ]}
                />
            </div>
            <Table
                loading={loading}
                dataSource={data}
                columns={columns}
                size='small'
                bordered
                pagination={false}
                rowClassName={(record, index) => {
                    if (record.stock_status === 'NOT FOUND') {
                        return 'error-row';
                    }
                    else if (record.stock_status === 'MATCHING') {
                        return 'success-row';
                    }
                    else {
                        return 'warning-row';
                    }
                }}

            />
        </div>
    );
}



const BoxWiseComparison = ({ sessionData, stockTransferId }) => {
    const [masterState, setMasterState] = useState([]);
    const orgID = useSelector((state) => state.globalReducer.selectedOrg.orgId);
    const navigate = useNavigate();
    // The below state is after the search is done
    const [data, setData] = useState([]);
    const [s_id, setSID] = useState([]);

    const [loading, setLoading] = useState(true);

    // The below var is memoized to avoid re-rendering of the filters when the data is changed, If not, the filters will be calculated again and again infinitely
    const filterableColumns = useMemo(() =>
        ['status', 'box_no']
        , []);
    const [filterOptions, setFilterOptions] = useFilterOptions(masterState, filterableColumns);


    const getData = async () => {
        setLoading(true);
        await axios.get(`/reports/box_wise_data`, {
            params: {
                st_id: stockTransferId,
                ref_site_name: sessionData?.data?.reference_site,
            }
        })
            .then(res => {
                const data = res.data.data;
                console.log(res.data.st_id?.[0].stock_transfer_id);
                setMasterState(data);
                setSID(res.data.st_id?.[0].stock_transfer_id)
                setData(data);
            })
            .catch(err => {
                console.log(err);
                message.error('Error fetching Boxwise Data');
            })
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, [stockTransferId]);
    function changeID(record) {
        navigate(`/inventory/inward-outward/${s_id}?orgId=${orgID}&tab=box-wise`)
        window.location.reload();
    }


    const columns = [
        {
            title: 'Index',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Box No',
            dataIndex: 'box_no',
            key: 'box_no',
            width: 150,
            filters: filterOptions.box_no,
            onFilter: (value, record) => record.box_no == value,
            filterSearch: true,
        },
        {
            title: 'Expected Quantity',
            dataIndex: 'expected_qty',
            key: 'expected_qty',
            width: 150,
        },
        {
            title: 'Found Quantity',
            dataIndex: 'found_qty',
            key: 'found_qty',
            width: 150,
        },
        {
            title: 'Outward Count',
            dataIndex: 'outward_count',
            key: 'outward_count',
            width: 150,
            render: (text, record) => {
                const color = record.outward_count === record.found_qty ? 'green' : 'red';
                if (record.outward_count === 'Multiple Outward' || record.outward_count === 'No Outward Data') {
                    return (
                        <Tag color={color}>{record.outward_count}</Tag>
                    );
                }
                else {
                    return (
                        <Link to={`/inventory/inward-outward/${s_id}?orgId=${orgID}&tab=box-wise`}>
                            <Tag color={color}>{record.outward_count}</Tag>
                        </Link>
                    );
                }
                // return (
                // <Link to={`/rfid-reports/inward-outward/${s_id}?orgId=${orgID}&tab=box-wise`}>
                //     <Tag color={color}>{record.outward_count}</Tag>
                // </Link>
                // );
            },
            hidden: sessionData?.data?.inward_outward === 'inward' ? false : true,
        },
        {
            title: 'Action',
            key: 'action',
            width: '80px',
            render: (_, record) => (
                <div className='actions-outer-div'>
                    {/* <InwardExportToExcel order_id={record.order_id} invoice_no={record.order_number} /> */}
                    <CoptToClipBoardInward order_id={record.order_id} invoice_no={record.order_number} box_no={record.box_no} stockTransferId={stockTransferId} />
                </div>
            ),
        },


    ].filter((item) => !item.hidden);

    return (
        <div className='my-form-outer' style={{ paddingBottom: '20px' }}>
            <div className='my-form-header'>
                <span className="actions-outer-div">
                    <ExportToExcelButton
                        fileName={`box-wise-${stockTransferId}`}
                        sheets={[
                            {
                                sheetName: `box-wise-${stockTransferId}`,
                                data: data,
                                columns: columns.slice(1, columns.length - 1),
                            },
                        ]}
                        buttonDisabled={loading}
                        buttonLoading={loading}
                    />
                </span>
                <SearchComponent
                    masterState={masterState}
                    state={data}
                    setState={setData}
                    searchOptions={[
                        { keyName: 'box_no', label: 'Box No' },
                    ]}
                />
            </div>
            <Table
                loading={loading}
                dataSource={data}
                columns={columns}
                size='small'
                bordered
                pagination={false}
                rowClassName={(record, index) => {
                    if (record.found_qty < record.expected_qty) {
                        return 'error-row';
                    }
                    else if (record.found_qty > record.expected_qty) {
                        return 'warning-row';
                    }
                    else if (record.found_qty == record.expected_qty) {
                        return 'success-row';
                    }
                }}
                rowKey={record => record.box_no}
                expandable={{
                    rowExpandable: record => record?.box_no?.length,
                    expandedRowRender: record => (
                        <ExpandProductCodeDetails
                            stockTransferId={stockTransferId}
                            box_no={record.box_no}
                        />
                    ),
                }}
            />
        </div>
    );
}


const ExpandProductCodeDetails = ({ stockTransferId, box_no }) => {
    const [masterState, setMasterState] = useState([]);


    // The below state is after the search is done
    const [data, setData] = useState([]);
    const [inward_outward, setinward_outwarddata] = useState([]);
    const [loading, setLoading] = useState(true);

    // The below var is memoized to avoid re-rendering of the filters when the data is changed, If not, the filters will be calculated again and again infinitely
    const filterableColumns = useMemo(() =>
        []
        , []);
    const [filterOptions, setFilterOptions] = useFilterOptions(masterState, filterableColumns);

    const [categoryColumns, setCategoryColumns] = useState([]);

    const getData = async () => {
        setLoading(true);
        await axios.get(`/reports/expand_product_code_details`, {
            params: {
                st_id: stockTransferId,
                box_no: box_no,
            }
        })
            .then(res => {
                const data = res.data.data;
                const inward_outward = res.data.inward_outward;
                const newColumns = res.data.columns;

                setMasterState(data);
                setCategoryColumns(newColumns);
                setData(data);
                setinward_outwarddata(inward_outward);
            })
            .catch(err => {
                console.log(err);
                message.error('Error fetching Product Code Data');
            })
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, [stockTransferId]);



    const columns = [
        {
            title: 'Index',
            dataIndex: 'index',
            key: 'index',
            width: 30,
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Product Code',
            dataIndex: 'product_code',
            key: 'product_code',
            width: 150,
            render: (text, record) => <ProductCodeComponent productCode={text} />,
        },
        {
            title: 'Expected Quantity',
            dataIndex: 'expected_qty',
            key: 'expected_qty',
            width: 150,
        },
        {
            title: 'Found Quantity',
            dataIndex: 'found_qty',
            key: 'found_qty',
            width: 150,
        },
        {
            title: 'Outward Count',
            dataIndex: 'outward_count',
            key: 'outward_count',
            width: 150,
            hidden: inward_outward === 'inward' ? false : true,
        }
    ].filter((item) => !item.hidden);

    return (
        <div className='my-form-outer' style={{ paddingBottom: '20px', paddingLeft: '60px' }}>
            <div className='my-form-header'>
                <span className="actions-outer-div">
                    <ExportToExcelButton
                        fileName={`box-no-${box_no}`}
                        sheets={[
                            {
                                data: data,
                                columns: columns.slice(1, columns.length),
                            },
                        ]}
                        buttonDisabled={loading}
                        buttonLoading={loading}
                        buttonProps={{ type: 'default' }}
                    />
                </span>
                <SearchComponent
                    masterState={masterState}
                    state={data}
                    setState={setData}
                    searchOptions={[
                        { keyName: 'product_code', label: 'Product Code' },
                    ]}
                />
            </div>
            <Table
                loading={loading}
                dataSource={data}
                columns={columns}
                size='small'
                bordered
                pagination={false}
                rowClassName={(record, index) => {
                    if (record.found_qty < record.expected_qty) {
                        return 'error-row';
                    }
                    else if (record.found_qty > record.expected_qty) {
                        return 'warning-row';
                    }
                    else if (record.found_qty == record.expected_qty) {
                        return 'success-row';
                    }
                }}
            />
        </div>
    );
}



const ExpandBoxWiseProductCodes = ({ stockTransferId, product_code }) => {
    const [masterState, setMasterState] = useState([]);


    // The below state is after the search is done
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    // The below var is memoized to avoid re-rendering of the filters when the data is changed, If not, the filters will be calculated again and again infinitely
    const filterableColumns = useMemo(() =>
        ['box_no']
        , []);
    const [filterOptions, setFilterOptions] = useFilterOptions(masterState, filterableColumns);

    const getData = async () => {
        setLoading(true);
        await axios.get(`/reports/expand_box_wise_product_codes`, {
            params: {
                st_id: stockTransferId,
                product_code: product_code,
            }
        })
            .then(res => {
                const data = res.data.data;

                setMasterState(data);
                setData(data);
            })
            .catch(err => {
                console.log(err);
                message.error('Error fetching Boxwise Data');
            })
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, [stockTransferId]);



    const columns = [
        {
            title: 'Index',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Box No',
            dataIndex: 'box_no',
            key: 'box_no',
            width: 150,
            filters: filterOptions.box_no,
            onFilter: (value, record) => record.box_no == value,
            filterSearch: true,
        },
        {
            title: 'Expected Quantity',
            dataIndex: 'expected_qty',
            key: 'expected_qty',
            width: 150,
        },
        {
            title: 'Found Quantity',
            dataIndex: 'found_qty',
            key: 'found_qty',
            width: 150,
        },
    ];

    return (
        <div className='my-form-outer' style={{ paddingBottom: '20px', paddingLeft: '60px' }}>
            <div className='my-form-header'>
                <span className="actions-outer-div">
                    <ExportToExcelButton
                        fileName={`product-code-${product_code}`}
                        sheets={[
                            {
                                data: data,
                                columns: columns.slice(1, columns.length),
                            },
                        ]}
                        buttonDisabled={loading}
                        buttonLoading={loading}
                        buttonProps={{ type: 'default' }}
                    />
                </span>
                <SearchComponent
                    masterState={masterState}
                    state={data}
                    setState={setData}
                    searchOptions={[
                        { keyName: 'box_no', label: 'Box No' },
                    ]}
                />
            </div>
            <Table
                loading={loading}
                dataSource={data}
                columns={columns}
                size='small'
                bordered
                pagination={false}
                rowClassName={(record, index) => {
                    if (record.found_qty < record.expected_qty) {
                        return 'error-row';
                    }
                    else if (record.found_qty > record.expected_qty) {
                        return 'warning-row';
                    }
                    else if (record.found_qty == record.expected_qty) {
                        return 'success-row';
                    }
                }}
            />
        </div>
    );
}
